import { Fragment, useMemo, useState } from "react";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DataTable from "../../Components/DataTable";
import { createColumnHelper } from "@tanstack/react-table";
import { StatusChip } from "../../Components/common/StatusChip";
import { PageHeader } from "../../Components/common/PageHeader";

export const CountryList = () => {
  const { getData } = useDataFetch();

  const { data, isLoading } = getData(
    ["countries"],
    "/product/all/countries",
    {
      enabled: true,
    }
  );

  const columnHelper = createColumnHelper();

  const columns = useMemo(() => [
    columnHelper.accessor("name", {
      header: "Nombre",
      cell: info => (
        <strong>{info.getValue()}</strong>
      ),
    }),
    columnHelper.accessor("status", {
      header: "Estado",
      cell: info => {
        const status = info.getValue();
        return <StatusChip tone={status ? "success" : "danger"}>{status ? "Activo" : "Inactivo"}</StatusChip>;
      },
    }),
    columnHelper.display({
      id: "acciones",
      header: "Acciones",
      cell: props => {
        const isActive = props.row.original.status;
        const text = isActive ? "Inactivar" : "Activar";

        return (
          <button type="button" className={`btn btn-sm ${isActive ? "btn-outline-danger" : "btn-outline-success"}`}>
            {text}
          </button>
        );
      },
    }),
  ], []);

  const countries = data?.data?.countries ?? [];

  // `/product/all/countries` no pagina en el backend: pagina en cliente
  // sobre lo ya cargado, sin duplicar el fetch.
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const pageData = countries.slice(
    pagination.pageIndex * pagination.pageSize,
    (pagination.pageIndex + 1) * pagination.pageSize
  );

  return (
    <Fragment>
      <PageHeader title="Países" crumbs={[{ label: "Otros" }, { label: "Países" }]} />

      <DataTable
        data={pageData}
        total={countries.length}
        pagination={pagination}
        setPagination={setPagination}
        columns={columns}
        progressPending={isLoading}
        emptyMessage="No hay países registrados."
      />
    </Fragment>
  );
};
